//
import _mock from '../_mock';

// ----------------------------------------------------------------------

export const _analyticPost = [...Array(2)].map((_, index) => ({
  id: [
    'convocatoria-a',
    'convocatoria-b'
  ],
  title: [
    'Convocatoria A',
    'Convocatoria B',
  ][index],
  description: [
    'Pequeña descripción',
    'Pequeña descripción',
  ][index],
  image: _mock.image.cover(index),
}));

export const _analyticCallsClose = [...Array(0)].map((_, index) => ({
  id: _mock.id(index),
  title: [
    'Convocatoria c',
  ][index],
  description: [
    'Pequeña descripción',
  ][index],
  image: _mock.image.cover(index),
}));

export const _analyticOrderTimeline = [...Array(1)].map((_, index) => ({
  id: _mock.id(index),
  title: [
    'Convocatoria C',
  ][index],
  type: `order${index + 1}`,
  time: _mock.time(index),
}));

export const _analyticTraffic = [
  {
    value: 'facebook',
    label: 'FaceBook',
    total: 323234,
  },
  {
    value: 'google',
    label: 'Google',
    total: 341212,
  },
  {
    value: 'linkedin',
    label: 'Linkedin',
    total: 411213,
  },
  {
    value: 'twitter',
    label: 'Twitter',
    total: 443232,
  },
];
